import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CloudAuthenticationService } from 'src/app/services/cloud-authentication.service';
import { IsAuthenticated } from 'src/app/interfaces/services/user.interface';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { StorageKeys } from 'src/app/Util/storage-keys';
import { QuotationPathEnum } from 'src/app/enums/quotation.enum';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate, IsAuthenticated {

  constructor(public router: Router, private authSvc: CloudAuthenticationService,private localStorageSvc:LocalStorageService) { }

  private storeEmailPathInSessionStorage(queryParams:any,state: RouterStateSnapshot){
    if('frompath' in queryParams && queryParams['frompath'] == QuotationPathEnum.EMAIL_LINK){
      this.localStorageSvc.setItemSessionStorage(StorageKeys.email_path,encodeURI(state.url))
    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.storeEmailPathInSessionStorage(route.queryParams,state)
    if (this.isAuthenticated()) {
      return true;
    }
      
    this.router.navigate([environment.routes.login]);
    return false;
  }

  isAuthenticated(): boolean {
    return this.authSvc.isAuthenticated();
  }

}
